import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import './Zone.css'
import InputCustom from '../../../../components/elements/InputCustom';
import TextAreaCustom from '../../../../components/elements/TextAreaCustom';
import { v4 as uuidv4 } from 'uuid';
import SelectDropDown from '../../../../components/elements/SelectDropDown';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { postZone } from '../../../../store/Actions/ActionZone';
import { loadZonesType } from '../../../../store/Actions/ActionZoneType';
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom';

function AddZone({ open, setOpen, zone_id, warehouse_id, setIsAdd, setObjAdded }) {
    const { dispatch, langLocal, navigate, mode } = AbstructVar()
    const { zoneType, loadingZoneType } = useSelectorCustom()
    const { translate } = AbstructLang()
    const [name, setName] = useState('')
    const [symbol, setSymbol] = useState('')
    const [zone_type, setzone_type] = useState('')
    const [description, setDescription] = useState('')
    const [options, setOptions] = useState([])
    const [load, setLoad] = useState('')
    const generateUniqueId = () => {
        return uuidv4();
    };
    useEffect(() => {
        dispatch(loadZonesType())
    }, []);
    useEffect(() => {
        setOptions(zoneType?.map((type) => ({
            value: type?.id,
            label: type?.name +' / ' + type?.symbol 
        })))
    }, [zoneType])
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postZone(name, symbol, description, zone_type, zone_id, warehouse_id, setLoad));
    };
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `pop_center ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='div_pop_zone' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={{ overflow: "hidden" }} >
                {/*<p>{warehouse_id}</p>
                <p>{zone_id}</p>*/}
                <h2 className='add_zone' >{translate('add_zone')}</h2>
                <InputCustom
                    label='name'
                    iconType='pencil'
                    type='text'
                    onChange={(e) => setName(e.target.value)}
                />
                <InputCustom
                    label='symbol'
                    iconType='pencil'
                    type='text'
                    onChange={(e) => setSymbol(e.target.value)}
                />
                <div className='one-select' style={{ width: '98%', marginBottom: "20px", marginTop: "-10px" }} >
                    <span className={langLocal === 'ar' ? 'textAlignRight' : ''} >{translate('zone_typ')}</span>
                    <SelectDropDown
                        options={options}
                        varr={zone_type}
                        setVarr={setzone_type}
                    />
                </div>
                <TextAreaCustom
                    label='description'
                    onChange={(e) => setDescription(e.target.value)}
                    nameClass='textarea-general'
                />
                <br></br>
                <button className='btn_top_table' onClick={/*() => {
                    setIsAdd(true)
                    setObjAdded({
                        name: name,
                        symbol: symbol,
                        description: description,
                        id: generateUniqueId()
                    })
                }*/ handleSubmit} >
                    {
                        load ? "Loading ...":
                        translate('save')
                    }
                </button>
            </div>
        </RModal>
    )
}

export default AddZone
